import React from 'react';
import styled from 'styled-components';
import {
  CarResponsePhysicalProps,
  CarResponseGeneral,
} from '../../../../types/VehicleResponse';
import BrandLogo from '../../../common/src/components/BrandLogo';

interface Props {
  generalData: CarResponseGeneral;
  physicalData: CarResponsePhysicalProps;
  className?: string;
}

const VehicleInfoBadge: React.FC<React.PropsWithChildren<Props>> = ({
  generalData = {},
  physicalData = {},
  className,
}) => {
  const { brand, series, model_year, version } = generalData;
  return (
    <Container className={className}>
      <BrandLogo brand={brand} />
      <div>
        <VehicleTitle>
          {`${brand} ${series}${model_year ? '(' + model_year + ')' : ''} ${
            version || ''
          }`}
        </VehicleTitle>
        {physicalData?.color && (
          <ColorText>
            <ColorDot color={physicalData?.color_hex || 'black'} />
            {physicalData?.color}
          </ColorText>
        )}
      </div>
    </Container>
  );
};

const ColorDot = styled.span<{ color: string }>`
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 1rem;
  background-color: ${({ color }) => color};
  border: 1px solid ${({ theme }) => theme.gray[50]};
  margin-right: 0.4rem;
  display: inline-block;
`;

const ColorText = styled.p`
  color: ${({ theme }) => theme.labels.guaranteeText};
  font-size: 1.4rem;
  text-transform: capitalize;
  display: flex;
  align-items: center;

  @media print {
    font-size: 14px;
  }
`;

const VehicleTitle = styled.p`
  font-weight: 500;
  font-size: 1.6rem;
  @media print {
    font-size: 15px;
  }
`;

const Container = styled.div`
  background-color: white;
  line-height: 120%;
  border: 1px solid ${({ theme }) => theme.gray[100]};
  padding: 1.6rem;
  display: grid;
  align-items: center;
  grid-template-columns: 4rem auto;
  grid-gap: 1.6rem;
  width: 100%;
  max-width: 32rem;
  min-height: 7.6rem;
  border-radius: 0.5rem;

  @media print {
    max-width: 60rem;
    line-height: 200%;
  }
`;

export default VehicleInfoBadge;
